import { useEffect, useState } from "react";
import { FaPlus, FaLock, FaUnlock, FaMoneyBillWave } from "react-icons/fa";

import AdminPage from "./components/AdminPage";

import { getUsers } from "./api/usersApi";

import PrimaryButton from "./components/PrimaryButton";
import SearchInput from "./components/SearchInput";
import AdminTable from "./components/AdminTable";

export default function Users() {
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchAllUsers = async () => {
    setLoading(true);

    try {
      const users = await getUsers();

      setAllUsers(users);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const filteredUsers = allUsers.filter((user) =>
    user.username?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <AdminPage
      title='Users'
      subtitle='Manage registered users.'
      actions={
        <PrimaryButton>
          <FaPlus />
          Add User
        </PrimaryButton>
      }
    >
      <SearchInput
        placeholder='Search users...'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <AdminTable
        headers={[
          "ID",
          "Username",
          "Email",
          "Balance",
          "Status",
          "Role",
          "Actions",
        ]}
        loading={loading}
        empty={!filteredUsers.length}
        emptyMessage='No users found.'
      >
        {filteredUsers.map((user) => (
          <tr
            key={user.id}
            className='
              border-t
              border-green-500/10
              hover:bg-white/5
              transition
            '
          >
            <td className='p-4 text-gray-300'>{user.id}</td>

            <td className='p-4 text-white font-medium'>{user.username}</td>

            <td className='p-4 text-gray-300'>{user.email}</td>

            <td className='p-4 text-green-300 font-semibold'>
              ${parseFloat(user.balance).toFixed(2)}
            </td>

            <td className='p-4'>
              <span
                className={`
                  px-3
                  py-1
                  rounded-full
                  text-xs
                  ${
                    user.status === "active"
                      ? "bg-green-900/40 text-green-400"
                      : "bg-red-900/40 text-red-400"
                  }
                `}
              >
                {user.status || "active"}
              </span>
            </td>

            <td className='p-4'>
              {user.is_admin ? (
                <span
                  className='
                    px-3
                    py-1
                    rounded-full
                    text-xs
                    bg-purple-900/40
                    text-purple-400
                  '
                >
                  Admin
                </span>
              ) : (
                <span className='text-gray-500'>User</span>
              )}
            </td>

            <td className='p-4'>
              <div className='flex gap-2'>
                <button
                  className={`
                    p-2
                    rounded-lg
                    text-white
                    transition
                    ${
                      user.status === "active"
                        ? "bg-red-600 hover:bg-red-700"
                        : "bg-green-600 hover:bg-green-700"
                    }
                  `}
                >
                  {user.status === "active" ? (
                    <FaLock size={14} />
                  ) : (
                    <FaUnlock size={14} />
                  )}
                </button>

                <button
                  className='
                    p-2
                    rounded-lg
                    bg-yellow-500/20
                    hover:bg-yellow-500/40
                    text-yellow-400
                    transition
                  '
                >
                  <FaMoneyBillWave size={14} />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </AdminTable>
    </AdminPage>
  );
}
